import { SidebarTagProps } from "components/templates/TagsSidebar";
import { TagCreateType } from "graphqlBase/types";
import { atom } from "recoil";

export const deviceTagsToCreateAtom = atom<TagCreateType[]>({
  key: "deviceTagsToCreateAtom",
  default: [],
});

export const deviceTagsforTagsListAtom = atom<SidebarTagProps[] | undefined>({
  key: "deviceTagsforTagsListAtom",
  default: undefined,
});

export const deviceTagIdsToDeleteAtom = atom<string[]>({
  key: "deviceTagIdsToDeleteAtom",
  default: [],
});
